module.exports = __webpack_public_path__ + "img/SES_69004100.ab962cbc.jpg";